
import React from 'react';
import { useObserver } from "mobx-react";
import { storeContext } from '../../context';
import {
  Form,
  Input,
  Row,
  Col,
} from 'antd';
import RegistryForm from '../RegistryForm';
import EquipmentTypeTags from './EquipmentTypeTags';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Nome',
    dataIndex: 'name',
    key: 'name',
  },
];

const labelCol = {
  xs: 24,
  sm: 24,
  md: 12,
  lg: 12,
  xl: 10,
};

let ContentForm = () => {
  const store = React.useContext(storeContext);

  const handleChange = (field, event) => {
    store.currentItem[field] = event.target.value;
  }
  
  return useObserver(() => (
    <Form layout="vertical">
      <Row gutter={16}>
        <Col {...labelCol}>
          <Form.Item label="Id">
            <Input value={store.currentItem.id}  disabled={true}/>
          </Form.Item>
        </Col>
        <Col {...labelCol}>
          <Form.Item label="Nome">
            <Input value={store.currentItem.name} onChange={handleChange.bind(this, 'name')} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  ));
}

const Equipments = () => {
  const store = React.useContext(storeContext);

  ContentForm = Form.create({})(ContentForm);

  store.editForm = undefined;
  store.columns = columns;
  store.url = '/equipment_type';

  ContentForm.tab = 'Info';
  EquipmentTypeTags.tab = "Tags";

  store.tabs = [ContentForm, EquipmentTypeTags];

  return (
    <div>
      <RegistryForm />
    </div>
  )
}

export default Equipments;